<template>
  <div v-if="showModal" class="model-wrapper">
    <div class="modal-container">
      <svg
        @click="hideModals"
        class="close"
        fill="currentColor"
        viewBox="0 0 20 20"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
          clip-rule="evenodd"
        ></path>
      </svg>
      <div class="modal-body">
        <slot></slot>
      </div>
    </div>
    <div class="modal-background" @click="hideModals"></div>
  </div>
</template>

<script>
export default {
  props: {
    showModal: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    hideModals() {
      this.$eventBus.$emit("hideModals");
    },
  },
};
</script>

<style lang="scss">
.model-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: transparent;

  .modal-container {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background-color: #fff;
    z-index: 10;
    width: 90%;
    max-width: 32rem;
    border-radius: 0.5rem;
    box-shadow: 0 0 #0000, 0 0 #0000, 0 1px 2px 0 rgba(0, 0, 0, 0.05);

    .close {
      width: 20px;
      margin-top: 20px;
      margin-left: auto;
      max-width: max-content;
      display: block;
      position: absolute;
      top: 0;
      right: 0;
      margin-right: 20px;
      z-index: 10;
    }
  }

  .modal-background {
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    background-color: #000;
    opacity: 0.4;
  }

  .modal-body {
    padding: 2rem;
    .form {
      div + div {
        margin-top: 20px;
      }
      label {
        display: block;
        font-size: 0.875rem;
        line-height: 1.25rem;
        color: rgb(55, 65, 81);
        font-weight: 500;
      }

      .input-container {
        margin-top: 0.25rem;
      }

      input {
        appearance: none;
        padding-top: 0.5rem;
        padding-right: 0.75rem;
        padding-bottom: 0.5rem;
        padding-left: 0.75rem;
        font-size: 1rem;
        line-height: 1.5rem;
        display: block;
        border: 1px solid rgb(209, 213, 219);
        width: 100%;
        box-shadow: 0 0 #0000, 0 0 #0000, 0 1px 2px 0 rgba(0, 0, 0, 0.05);
        border-radius: 0.375rem;

        @media (min-width: 640px) {
          font-size: 0.875rem;
          line-height: 1.25rem;
        }
      }
    }
  }

  .buttons {
    margin-top: 3rem;
    display: flex;
    justify-content: flex-end;
    button.btn {
      font-size: unset !important;
      border-radius: 0.375rem;
    }

    button + button {
      margin-left: 10px;
    }
  }
}
</style>